// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cea295bd","239":"2fed4e00","355":"f4d40217","453":"ca693d4f","732":"40c971c6","762":"ea8b0767"}[chunkId] + ".chunk.js";
};